<template>
  <div class="animated fadeIn">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-col lg="12" class="ml-auto">
      <notifications group="error" position="top center" class="mt-1" />
      <notifications group="success" position="top left" class="mt-1" />
      <notifications group="info" position="top left" class="mt-1" />
      <notifications group="warn" position="top left" class="mt-1" />
      <loading v-if="vLoading" />
      <v-row>
        <v-col lg="3">
          <b-card style="background-color: #effbfe !important">
            <b-card-text style="color: #547887 !important" class="text-center">
              <svg
                width="44"
                height="45"
                viewBox="0 0 55 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M38.9583 16.3333C38.9583 18.6408 38.2863 20.8964 37.0273 22.815C35.7682 24.7335 33.9786 26.2289 31.8849 27.1119C29.7912 27.9949 27.4873 28.226 25.2646 27.7758C23.0419 27.3257 21.0002 26.2145 19.3977 24.5829C17.7953 22.9513 16.704 20.8725 16.2618 18.6094C15.8197 16.3463 16.0466 14.0005 16.9139 11.8687C17.7811 9.73688 19.2498 7.91479 21.1341 6.63284C23.0184 5.35089 25.2338 4.66666 27.5 4.66666C30.5389 4.66666 33.4534 5.89582 35.6023 8.08374C37.7511 10.2717 38.9583 13.2391 38.9583 16.3333Z"
                  stroke="#547887"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M47.1858 51.3333C47.1858 42.3033 38.3629 35 27.5004 35C16.6379 35 7.81494 42.3033 7.81494 51.3333"
                  stroke="#547887"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <br />
              <h4 class="my-3">مشتری‌ها</h4>
              <h2>{{ dashboard.customerCounts }}</h2>
            </b-card-text>
          </b-card>
        </v-col>
        <v-col lg="3">
          <b-card style="background-color: #fdf3ec !important">
            <b-card-text style="color: #927666 !important" class="text-center">
              <svg
                width="44"
                height="45"
                viewBox="0 0 55 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.3333 4.66666V11.6667"
                  stroke="#927666"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M36.6667 4.66666V11.6667"
                  stroke="#927666"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.0417 30.3333H34.375"
                  stroke="#927666"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.0417 39.6667H27.5"
                  stroke="#927666"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M36.6667 8.16666C44.2979 8.58666 48.125 11.55 48.125 22.5167V36.9367C48.125 46.55 45.8333 51.3567 34.375 51.3567H20.625C9.16667 51.3567 6.875 46.55 6.875 36.9367V22.5167C6.875 11.55 10.7021 8.60999 18.3333 8.16666H36.6667Z"
                  stroke="#927666"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <br />
              <h4 class="my-3">استعلام‌ها</h4>
              <h2>{{ dashboard.orderCounts }}</h2>
            </b-card-text>
          </b-card>
        </v-col>
        <v-col lg="3">
          <b-card style="background-color: #f5f2fe !important">
            <b-card-text style="color: #605a89 !important" class="text-center">
              <svg
                width="44"
                height="45"
                viewBox="0 0 54 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.9001 15.1667H35.1001C42.7501 15.1667 43.5151 18.8767 44.0326 23.4033L46.0576 40.9033C46.7101 46.6433 45.0001 51.3333 37.1251 51.3333H16.8976C9.00005 51.3333 7.29005 46.6433 7.96505 40.9033L9.99005 23.4033C10.4851 18.8767 11.2501 15.1667 18.9001 15.1667Z"
                  stroke="#605A89"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M18.0009 18.6664V10.4997C17.9556 9.72146 18.07 8.94206 18.3367 8.21304C18.6034 7.48402 19.0161 6.82197 19.5478 6.27064C20.0794 5.7193 20.7178 5.29122 21.4208 5.01468C22.1238 4.73815 22.8754 4.61944 23.6259 4.66641H30.3759C31.1264 4.61944 31.8779 4.73815 32.5809 5.01468C33.2839 5.29122 33.9223 5.7193 34.4539 6.27064C34.9856 6.82197 35.3984 7.48402 35.665 8.21304C35.9317 8.94206 36.0462 9.72146 36.0009 10.4997V18.6664"
                  stroke="#605A89"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M45.9225 39.7367H18"
                  stroke="#605A89"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <br />
              <h4 class="my-3">سفارش‌ها</h4>
              <h2>{{ dashboard.factoryOrdersCounts }}</h2>
            </b-card-text>
          </b-card>
        </v-col>
        <v-col lg="3">
          <b-card style="background-color: #f0fef1 !important">
            <b-card-text style="color: #6f9a6e !important" class="text-center">
              <svg
                width="44"
                height="45"
                viewBox="0 0 55 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M50.4167 14V19.6467C50.4787 20.4533 50.3683 21.264 50.0931 22.0231C49.8179 22.7821 49.3845 23.4714 48.8225 24.0435C48.2606 24.6157 47.5836 25.057 46.8382 25.3372C46.0927 25.6174 45.2964 25.7298 44.5042 25.6667H36.6667V9.35666C36.6721 8.11046 37.1623 6.91723 38.0299 6.03822C38.8976 5.15921 40.0719 4.66603 41.2959 4.66666C43.72 4.67592 46.0416 5.66371 47.7514 7.41339C49.4612 9.16306 50.4197 11.5318 50.4167 14Z"
                  stroke="#6F9A6E"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M4.58331 16.3333V49C4.58331 49.4333 4.70183 49.8581 4.92557 50.2267C5.14932 50.5953 5.46946 50.8932 5.85012 51.087C6.23077 51.2808 6.65691 51.3628 7.08078 51.3239C7.50465 51.285 7.90951 51.1267 8.24998 50.8667L12.1687 47.88C12.6155 47.5401 13.1681 47.3765 13.7242 47.4194C14.2803 47.4623 14.8023 47.7088 15.1937 48.1133L18.9979 52.01C19.4306 52.4471 20.0154 52.6924 20.625 52.6924C21.2345 52.6924 21.8194 52.4471 22.2521 52.01L26.1021 48.09C26.4898 47.6942 27.0053 47.4549 27.553 47.4163C28.1007 47.3777 28.6436 47.5424 29.0812 47.88L33 50.8667C33.3405 51.1267 33.7453 51.285 34.1692 51.3239C34.593 51.3628 35.0192 51.2808 35.3998 51.087C35.7805 50.8932 36.1006 50.5953 36.3244 50.2267C36.5481 49.8581 36.6666 49.4333 36.6666 49V9.33332C36.6703 8.09678 37.1543 6.91194 38.0131 6.03757C38.8718 5.1632 40.0355 4.67035 41.25 4.66666L13.75 4.66666C6.87498 4.66666 4.58331 8.84332 4.58331 14V16.3333Z"
                  stroke="#6F9A6E"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M20.625 30.3567H27.5"
                  stroke="#6F9A6E"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M20.625 21.0233H27.5"
                  stroke="#6F9A6E"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M13.7408 30.3333H13.7618"
                  stroke="#6F9A6E"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M13.7408 21H13.7618"
                  stroke="#6F9A6E"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <br />
              <h4 class="my-3">اقلام سفارش</h4>
              <h2>{{ dashboard.orderItemsCounts }}</h2>
            </b-card-text>
          </b-card>
        </v-col>
      </v-row>
      <br />
    </v-col>

    <hr />
    <v-tabs v-model="tab">
      <v-tab> استعلام‌ها </v-tab>
      <v-tab> سفارش‌ها </v-tab>
      <v-tab> گزارش مالی </v-tab>
      <v-tab> انبار </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" touchless>
      <v-tab-item>
        <b-card header-bg-variant="primary" header-text-variant="white">
          <v-row v-if="loaded">
            <v-col lg="12">
              <line-chart
                :chartdata="dashboard.ordersPerMonthRate"
                :options="ordersPerMonthRateOptions"
              >
              </line-chart>
            </v-col>
            <v-col lg="12">
              <hr />
            </v-col>
            <v-col lg="12">
              <bar-chart
                :chartData="dashboard.ordersPerMonthCount"
                :options="countBarChartOptions"
              >
              </bar-chart>
            </v-col>
            <v-col lg="12"
              ><pie-chart
                :chartdata="dashboard.statusCounts"
                :options="statusCountsOptions"
              >
              </pie-chart>
            </v-col>
          </v-row>
          <div v-else class="text-center">
            <v-progress-circular
              :size="50"
              :width="7"
              color="dark"
              indeterminate
            ></v-progress-circular>
          </div>
        </b-card>
      </v-tab-item>
      <v-tab-item>
        <b-card header-bg-variant="primary" header-text-variant="white">
          <v-row v-if="loaded">
            <v-col lg="6">
              <pie-chart
                :chartdata="dashboard.orderItemStatusCounts"
                :options="orderItemStatusCountsOptions"
              >
              </pie-chart>
            </v-col>
            <v-col lg="6">
              <pie-chart
                :chartdata="dashboard.factoryStatusCounts"
                :options="factoryStatusCountsOptions"
              >
              </pie-chart>
            </v-col>
          </v-row>
          <div v-else class="text-center">
            <v-progress-circular
              :size="50"
              :width="7"
              color="dark"
              indeterminate
            ></v-progress-circular>
          </div>
        </b-card>
      </v-tab-item>
      <v-tab-item>
        <b-card header-bg-variant="primary" header-text-variant="white">
          <v-row v-if="loaded">
            <v-col lg="12">
              <bar-chart
                :chartData="dashboard.ordersPerMonthPrice"
                :options="priceBarChartOptions"
              >
              </bar-chart>
            </v-col>
            <v-col lg="6">
              <pie-chart
                :chartdata="dashboard.priceFactoryPerCurrency"
                :options="priceFactoryPerCurrencyOptions"
              >
              </pie-chart>
            </v-col>
            <v-col lg="6">
              <pie-chart
                :chartdata="dashboard.pricePerCurrency"
                :options="pricePerCurrencyOptions"
              >
              </pie-chart>
            </v-col>
          </v-row>
          <div v-else class="text-center">
            <v-progress-circular
              :size="50"
              :width="7"
              color="dark"
              indeterminate
            ></v-progress-circular>
          </div>
        </b-card>
      </v-tab-item>
      <v-tab-item>
        <b-card header-bg-variant="primary" header-text-variant="white">
          <v-row v-if="loaded">
            <v-col lg="6">
              <line-chart
                :chartdata="dashboard.materialCountsPerDay['برگ']"
                :options="materialWarehouseCountsPerDayOptions"
              >
              </line-chart>
            </v-col>
            <v-col lg="6">
              <line-chart
                :chartdata="dashboard.materialCountsPerDay['بسته']"
                :options="materialWarehouseCountsPerDayOptions"
              >
              </line-chart>
            </v-col>
            <v-col lg="6">
              <line-chart
                :chartdata="dashboard.materialCountsPerDay['شاخه']"
                :options="materialWarehouseCountsPerDayOptions"
              >
              </line-chart>
            </v-col>
            <v-col lg="6">
              <line-chart
                :chartdata="dashboard.materialCountsPerDay['عدد']"
                :options="materialWarehouseCountsPerDayOptions"
              >
              </line-chart>
            </v-col>
            <v-col lg="6">
              <line-chart
                :chartdata="dashboard.materialCountsPerDay['کلاف']"
                :options="materialWarehouseCountsPerDayOptions"
              >
              </line-chart>
            </v-col>
            <v-col lg="6">
              <line-chart
                :chartdata="dashboard.materialCountsPerDay['کیلوگرم']"
                :options="materialWarehouseCountsPerDayOptions1"
              >
              </line-chart>
            </v-col>
            <v-col lg="12">
              <line-chart
                :chartdata="dashboard.productWarehouseCountsPerDay"
                :options="materialWarehouseCountsPerDayOptions1"
              >
              </line-chart>
            </v-col>
          </v-row>
          <div v-else class="text-center">
            <v-progress-circular
              :size="50"
              :width="7"
              color="dark"
              indeterminate
            ></v-progress-circular>
          </div>
        </b-card>
      </v-tab-item>
    </v-tabs-items>
   
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";
import Var from "../../../variables";
import router from "../../router";

import BarChart from "/src/components/charts/BarExample.vue";
import PieChart from "/src/components/charts/PieExample.vue";
import LineChart from "/src/components/charts/LineExample.vue";

export default {
  components: {
  
    BarChart,
    PieChart,
    LineChart,
  },
  data: function () {
    return {
      vLoading: true,
      guide: false,
      isBusy: false,
      dashboard: {},
      tab: null,
      striped: true,

      countBarChartOptions: {
        title: {
          display: true,
          fontSize: 14,
          position: "top",
          fontFamily: "iransans",
          text: "تعداد استعلام در هر ماه",
        },
        responsive: true,
        maintainAspectRatio: false,
        onClick: this.fetchMonthData,
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: false,
                labelString: "تعداد استعلام در هر ماه",
                fontFamily: "iransans",
              },
              ticks: {
                min: 0,
                fontFamily: "iransans",
                stepSize: 50,
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: false,
                labelString: "سال و ماه",
                fontFamily: "iransans",
              },
              ticks: {
                fontFamily: "iransans",
              },
            },
          ],
        },
        legend: {
          display: true,
          position: "bottom",
          labels: {
            usePointStyle: true,
            fontFamily: "iransans",
          },
        },
        tooltips: {
          titleFontFamily: "iransans",
          bodyFontFamily: "iransans",
        },
      },
      ordersPerMonthRateOptions: {
        title: {
          display: true,
          fontSize: 14,
          position: "top",
          fontFamily: "iransans",
          text: "درصد استعلام‌های تایید شده",
        },
        responsive: true,
        maintainAspectRatio: false,
        onClick: this.fetchMonthData,
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: false,
                labelString: "تعداد استعلام در هر ماه",
                fontFamily: "iransans",
              },
              ticks: {
                min: 0,
                fontFamily: "iransans",
                stepSize: 10,
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: false,
                labelString: "سال و ماه",
                fontFamily: "iransans",
              },
              ticks: {
                fontFamily: "iransans",
              },
            },
          ],
        },
        legend: {
          display: true,
          position: "bottom",
          labels: {
            usePointStyle: true,
            fontFamily: "iransans",
          },
        },
        tooltips: {
          titleFontFamily: "iransans",
          bodyFontFamily: "iransans",
        },
      },
      materialWarehouseCountsPerDayOptions: {
        title: {
          display: true,
          fontSize: 14,
          position: "top",
          fontFamily: "iransans",
          text: "موجودی انبار 30 روز گذشته",
        },
        responsive: true,
        maintainAspectRatio: false,
        onClick: this.fetchMonthData,
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: false,
                labelString: "تعداد استعلام در هر ماه",
                fontFamily: "iransans",
              },
              ticks: {
                fontFamily: "iransans",
               stepSize: 1,
            beginAtZero: true,
                
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: false,
                labelString: "سال و ماه",
                fontFamily: "iransans",
              },
              ticks: {
                fontFamily: "iransans",
              },
            },
          ],
        },
        legend: {
          display: true,
          position: "bottom",
          labels: {
            usePointStyle: true,
            fontFamily: "iransans",
          },
        },
        tooltips: {
          titleFontFamily: "iransans",
          bodyFontFamily: "iransans",
        },
      },
      materialWarehouseCountsPerDayOptions1: {
        title: {
          display: true,
          fontSize: 14,
          position: "top",
          fontFamily: "iransans",
          text: "موجودی انبار 30 روز گذشته",
        },
        responsive: true,
        maintainAspectRatio: false,
        onClick: this.fetchMonthData,
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: false,
                labelString: "تعداد استعلام در هر ماه",
                fontFamily: "iransans",
              },
              ticks: {
                fontFamily: "iransans",
              //  stepSize: 1,
               beginAtZero: true,
                
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: false,
                labelString: "سال و ماه",
                fontFamily: "iransans",
              },
              ticks: {
                fontFamily: "iransans",
              },
            },
          ],
        },
        legend: {
          display: true,
          position: "bottom",
          labels: {
            usePointStyle: true,
            fontFamily: "iransans",
          },
        },
        tooltips: {
          titleFontFamily: "iransans",
          bodyFontFamily: "iransans",
        },
      },
      priceBarChartOptions: {
        title: {
          display: true,
          fontSize: 14,
          position: "top",
          fontFamily: "iransans",
          text: "مبلغ استعلام‌ها و سفارش‌ها در هر ماه",
        },
        responsive: true,
        maintainAspectRatio: false,
        onClick: this.fetchMonthData,
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString:
                  "مبلغ استعلام‌ها و سفارش‌ها در هر ماه (میلیون تومان)",
                fontFamily: "iransans",
              },
              ticks: {
                min: 0,
                fontFamily: "iransans",
                stepSize: 20000,
                callback: function (value, index, values) {
                  return value.toLocaleString();
                },
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: false,
                labelString: "سال و ماه",
                fontFamily: "iransans",
              },
              ticks: {
                fontFamily: "iransans",
              },
            },
          ],
        },
        legend: {
          display: true,
          position: "bottom",
          labels: {
            usePointStyle: true,
            fontFamily: "iransans",
          },
        },
        tooltips: {
          titleFontFamily: "iransans",
          bodyFontFamily: "iransans",
          callbacks: {
            title: function (tooltipItem, data) {
              return data["labels"][tooltipItem[0]["index"]];
            },
            label: function (tooltipItem, data) {
              var myLabel =
                data["datasets"][tooltipItem.datasetIndex]["label"] +
                ": " +
                (
                  Math.round(
                    data["datasets"][tooltipItem.datasetIndex]["data"][
                      tooltipItem["index"]
                    ] / 100
                  ) / 10
                ).toLocaleString() +
                " میلیارد تومان";
              return myLabel;
            },
          },
        },
      },

      orderItemStatusCountsOptions: {
        title: {
          display: true,
          fontSize: 14,
          position: "top",
          fontFamily: "iransans",
          text: "اقلام سفارش به تفکیک وضعیت",
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          usePointStyle: true,
          position: "bottom",
          labels: {
            usePointStyle: true,
            fontFamily: "iransans",
          },
        },
        tooltips: {
          titleFontFamily: "iransans",
          bodyFontFamily: "iransans",
        },
      },
      factoryStatusCountsOptions: {
        title: {
          display: true,
          fontSize: 14,
          position: "top",
          fontFamily: "iransans",
          text: "تعداد سفارش‌ها به تفکیک وضعیت",
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          usePointStyle: true,
          position: "bottom",
          labels: {
            usePointStyle: true,
            fontFamily: "iransans",
          },
        },
        tooltips: {
          titleFontFamily: "iransans",
          bodyFontFamily: "iransans",
        },
      },
      priceFactoryPerCurrencyOptions: {
        title: {
          display: true,
          fontSize: 14,
          position: "top",
          fontFamily: "iransans",
          text: "تعداد سفارش به تفکیک واحد پول",
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          usePointStyle: true,
          position: "bottom",
          labels: {
            usePointStyle: true,
            fontFamily: "iransans",
          },
        },
        tooltips: {
          titleFontFamily: "iransans",
          bodyFontFamily: "iransans",
        },
      },
      pricePerCurrencyOptions: {
        title: {
          display: true,
          fontSize: 14,
          position: "top",
          fontFamily: "iransans",
          text: "تعداد استعلام به تفکیک واحد پول",
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          usePointStyle: true,
          position: "bottom",
          labels: {
            usePointStyle: true,
            fontFamily: "iransans",
          },
        },
        tooltips: {
          titleFontFamily: "iransans",
          bodyFontFamily: "iransans",
        },
      },
      statusCountsOptions: {
        title: {
          display: true,
          fontSize: 14,
          position: "top",
          fontFamily: "iransans",
          text: "تعداد استعلام به تفکیک وضعیت",
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          usePointStyle: true,
          position: "bottom",
          labels: {
            usePointStyle: true,
            fontFamily: "iransans",
          },
        },
        tooltips: {
          titleFontFamily: "iransans",
          bodyFontFamily: "iransans",
        },
       
      },

      loaded: false,
    };
  },
  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },

    getChartData() {
      this.loaded = false;
      Axios.post(
        this.baseUrl + "/ppkpms/user/analyticDashboard",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.dashboard = res.data;
            this.dashboard.ordersPerMonthRate.datasets[0].borderColor =
              "#4DA0E799";
            this.dashboard.ordersPerMonthRate.datasets[0].backgroundColor =
              "#4DA0E711";
            this.dashboard.ordersPerMonthRate.datasets[0].lineTension = 0;

            this.dashboard.ordersPerMonthRate.datasets[1].borderColor =
              "#A59DDD";
            this.dashboard.ordersPerMonthRate.datasets[1].backgroundColor =
              "#A59DDD11";
            this.dashboard.ordersPerMonthRate.datasets[1].lineTension = 0;

            this.loaded = true;
            this.vLoading = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
  },

  mounted() {
    this.getChartData();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
